import style from './style'
import vClass from './class'
import component from './component'
import prop from './prop'
import transition from './transition'

export default {
  style,
  'class': vClass,
  component,
  prop,
  transition
}



//////////////////
// WEBPACK FOOTER
// ./~/vue/src/directives/internal/index.js
// module id = ./node_modules/vue/src/directives/internal/index.js
// module chunks = 54